import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeRaw from "rehype-raw";

interface MarkdownRendererProps {
  content: string;
}

export const MarkdownRenderer: React.FC<MarkdownRendererProps> = ({
  content,
}) => {
  return (
    // The markdown-body class applies our new typography styles
    <div className="markdown-body">
      {/* Rendering markdown with remark and rehype plugins */}
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
        components={{
          // Wrap the table in a horizontally scrollable div
          table: ({ node, ...props }) => (
            <div
              style={{
                overflowX: "auto",
                width: "100%",
                marginBottom: "1.5rem",
              }}
            >
              <table {...props} style={{ margin: 0 }} />
            </div>
          ),
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};
